import { Alert, Button, EventCalendar } from '@all-manager/design-system-v2';
import CalendarItemDetail from '../CalendarItemDetail/CalendarItemDetail';
import { CALENDAR_CATEGORIES } from '../../utils/calendarEvents';
import { useCalendarPlanning } from './useCalendarPlanning';

export default function CalendarPlanning() {
  const hook = useCalendarPlanning();

  return (
    <>
      <EventCalendar
        aria-label="Calendrier de la copropriété"
        events={hook.events}
        categories={CALENDAR_CATEGORIES}
        view={hook.view}
        onViewChange={hook.setView}
        visibleDate={hook.visibleDate}
        onVisibleDateChange={hook.setVisibleDate}
        onEventClick={hook.handleEventClick}
        loading={hook.isFetching}
        banner={hook.isError ? (
          <Alert
            severity="error"
            action={(
              <Button variant="text" size="small" color="error" onClick={hook.handleRetry}>
                Réessayer
              </Button>
            )}
          >
            Impossible de charger les événements de cette période.
          </Alert>
        ) : undefined}
        fill
      />

      {hook.selected ? (
        <CalendarItemDetail
          item={hook.selected.item}
          anchor={hook.selected.anchor}
          onClose={hook.handleCloseDetail}
        />
      ) : null}
    </>
  );
}
